"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _immutable = require("immutable");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const mapImmutablePropsToPlainProps = WrappedComponent => {
  function MapImmutableToPlain(wrappedComponentProps) {
    const propsJS = Object.keys(wrappedComponentProps).reduce((previous, current) => {
      /* eslint-disable no-param-reassign */
      /* eslint-disable react/destructuring-assignment */
      previous[current] = _immutable.Iterable.isIterable(wrappedComponentProps[current]) ? wrappedComponentProps[current].toJS() : wrappedComponentProps[current];
      return previous;
      /* eslint-enable react/destructuring-assignment */
      /* eslint-enable no-param-reassign */
    }, {});
    return /*#__PURE__*/_react.default.createElement(WrappedComponent, propsJS);
  }
  return MapImmutableToPlain;
};
var _default = mapImmutablePropsToPlainProps;
exports.default = _default;